import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { userAppContext } from '../../context/Context';
import { ChevronRightIcon, UserIcon, KeyIcon, StarIcon, DocumentTextIcon } from '@heroicons/react/24/solid';

const ProfileHashLinks = ({ hash }) => {
  const hashlinkBootstrapClasses = 'mb-1 dropdown-item-profile text-wrap';
  const { user } = userAppContext();

  const isAcademic = user?.['cognito:groups'][0] === 'ROLE_ACADEMIC';
  const isStandard = user?.['cognito:groups'][0] === 'ROLE_STANDARD';
  const isTrial = user?.['cognito:groups']?.includes('ROLE_TRIAL');

  const hashLinkContent = (id, HashLinkName) => {
    const hashLink = (
      <HashLink
        to={`${'#' + id}`}
        data-toggle="tab"
        data-target={`${'#' + id}`}
        className={`${hashlinkBootstrapClasses} ${hash === '' || hash === '#' + id ? 'active' : ''}`}
      >
        <div className="flex items-center justify-between gap-2">
          {HashLinkName === 'Profile Data' && <UserIcon className="w-4 h-4" />}
          {HashLinkName === 'API Key' && <KeyIcon className="w-4 h-4" />}
          {HashLinkName === 'Favorites' && <StarIcon className="w-4 h-4" />}
          {HashLinkName === 'Sticky Notes' && <DocumentTextIcon className="w-4 h-4" />}
          {HashLinkName} <ChevronRightIcon className="w-4 h-4" />
        </div>
      </HashLink>
    );

    return hashLink;
  };

  const profileDataHashLink = hashLinkContent('profileData', 'Profile Data');
  const apiKeyHashLink = hashLinkContent('apiKey', 'API Key');
  const favoritesHashLink = hashLinkContent('favorites', 'Favorites');
  const stickyNotesHashLink = hashLinkContent('stickyNotes', 'Sticky Notes');

  return (
    <React.Fragment>
      <div className="nav p-0 dropdown-menu-inline dropdown-menu-rounded dropdown-menu-hover-primary">
        {profileDataHashLink}
        {!isStandard && apiKeyHashLink}
        {!isAcademic && !isTrial && favoritesHashLink}
        {stickyNotesHashLink}
      </div>
    </React.Fragment>
  );
};

export default ProfileHashLinks;
